import React, {useEffect, useState} from "react";
import {useLocation} from "react-router-dom";
import RecitaReportTable from "./RecitaReportTable";
import Loader from "../../../../components/Loader/Loader";
import logo from "../../../../assets/img/profile/Emblem_of_Angola.png"
import {formatNumberToInternational} from "../../../../utils/utils";
export const FINANCIAL_HEAD = process.env.REACT_APP_FINANCIAL_HEAD;
export const EMBAIXADOR = process.env.REACT_APP_EMBAIXADOR;
export const COUNTRY = process.env.REACT_APP_COUNTRY;
const IncomeReport = () => {
    const [loading, setLoading] = useState(false);
    const [apiData, setApiData] = useState({});
    const [reportData, setReportData] = useState([]);
  

    const location = useLocation();
    const queryParams = new URLSearchParams(location.search);

    // Extract query parameters
    const organizationId = queryParams.get("organizationId");
    const yearMonth = queryParams.get("yearMonth");
    const year = queryParams.get("year"); 
    const quarter = queryParams.get("quarter");

    useEffect(() => {
        fetchRecitaReport(organizationId, year, quarter);
    }, []);

    const fetchRecitaReport = async (organizationId, year, quarter) => {
        setLoading(true);
        try {
            let apiUrl = `${process.env.REACT_APP_API_URL}/v1/reports/receita-quaterly?organizationId=${organizationId}&year=${year}&quarter=${quarter}`;
            const userToken = localStorage.getItem("token");
            const response = await fetch(apiUrl, {
                method: 'GET',
                headers: {
                    Authorization: `Bearer ${userToken}`,
                },
            });
            setLoading(false);
            if (response.ok) {
                const responseData = await response.json();
                if (responseData.data) {
                    setApiData(responseData.data);
                    setReportData(responseData.data.receitaReport);
                }
            } else {
                console.error('Error fetching API data:', response.status);
            }
        } catch (error) {
            setLoading(false);
            console.error('Error fetching API data:', error);
        }
    }


    const handlePrint = () => {
        window.print();
    };

    let mappedApiData = reportData.map((item) => ({
        description: item.description,
        totalJpy: formatNumberToInternational(item.totalJpy),
        totalUsd: formatNumberToInternational(item.totalUsd),
        totalEur: formatNumberToInternational(item.totalEur),
        totalAkz: formatNumberToInternational(item.totalAkz)
    }));

    return (
        <div className="p-2">
            <Loader show={loading}/>
            <div className="max-w-7xl mx-auto">
                {/* Header */}
                <div className="flex justify-between items-center mb-4 text-black dark:text-white">
                    <div className="flex-1 text-center">
                        <div className="flex items-center justify-center h-[100px]">
                            <img
                                src={logo}
                                alt="Logo"
                                className="w-[60px] h-[80px] object-contain"
                            />
                        </div>
                        <h2 className="text-md font-bold">MINISTÉRIO DAS FINANÇAS</h2>
                        <h2 className="text-md">DIRECÇÃO NACIONAL DE CONTABILIDADE</h2>
                        <h2 className="mt-2 text-md font-bold">EMBAIXADA DA REPÚBLICA DE ANGOLA NO {COUNTRY}</h2>
                        <h2 className="mt-2 text-md font-bold">RELAÇÃO DDOS RECUSOS RECEBIDOS TRIMESTRAL</h2>
                        <h2 className="text-md">MÊS DE {apiData.monthNameAndYear}</h2>
                        <h2 className="text-md uppercase font-bold mt-2"
                            style={{textAlign: 'left'}}>{apiData.organizationName}</h2>

                    </div>

                    <div className="text-right">
                        {/* <p className="text-md text-red-600">Câmbio: {apiData.exchangeRateText}</p> */}
                    </div>
                </div>

                {/* Print Button */}
                <div className="text-right mb-4">
                    <button
                        onClick={handlePrint}
                        className="linear mt-2 w-48 rounded-xl bg-brand-500 py-[12px] text-base font-medium text-white transition duration-200 hover:bg-brand-600 active:bg-brand-700 dark:bg-brand-400 dark:text-white dark:hover:bg-brand-300 dark:active:bg-brand-200 print:hidden">
                        Print
                    </button>

                </div>

                {/* Table */}
                {reportData?.length > 0 && (
                    <RecitaReportTable
                        tableData={mappedApiData}
                    />
                )}

                {/* Footer */}
                <div className="flex justify-between mt-4">

                    <div>
                        <hr className="mt-10 border-t-2 my-2" style={{borderTop: '2px solid black'}}/>
                        <p className="text-center">Adido Financeiro</p>
          <p className="font-bold">{FINANCIAL_HEAD}</p>
                    </div>
                    <div>
                        <hr className="mt-10 border-t-2 my-2" style={{borderTop: '2px solid black'}}/>
                        <p className="text-center">Embaixadora</p>
          <p className="font-bold">{EMBAIXADOR}</p>

                    </div>
                </div>
            </div>
        </div>
    );
};

export default IncomeReport;
